import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";

function AddCategory() {
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("id");
  const [category, setCategory] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [subcategories, setSubcategories] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isFormProcessing, setIsFormProcessing] = useState(false);

  const navigate = useNavigate();


  const handleAddCategory = async (e) => {
    e.preventDefault();

    setIsFormProcessing(true);
    let valid = true;

    // Validate form fields
    if (category.trim() === "") {
      setErrorMessage("Category is required");
      valid = false;
    } else {
      setErrorMessage("");
    }

    if (subcategory.trim() === "") {
      setErrorMessage("Subcategory is required");
      valid = false;
    } else {
      setErrorMessage("");
    }

    if (!valid) {
      setIsFormProcessing(false);
      return;
    }

    try {
      const apiUrl = categoryId
        ? `${process.env.REACT_APP_APIURL}category/update`
        : `${process.env.REACT_APP_APIURL}category/create`;

      const payload = {
        category: category,
        subcategory: subcategory,
        category_id: categoryId ? categoryId : "",
      };

      axios
        .post(apiUrl, payload)
        .then((res) => {
          if (res.data.status === "success") {
            setSuccessMessage(
              categoryId
                ? "Category updated successfully!"
                : "Category added successfully!"
            );
            setTimeout(() => {
              setSuccessMessage("");
              navigate("/category");
            }, 2000);
          } else {
            setErrorMessage("Failed to add/update category");
          }
        })
        .catch((err) => {
          console.error("Category creation/update error:", err);
          setErrorMessage("Failed to add/update category");
        })
        .finally(() => setIsFormProcessing(false));
    } catch (err) {
      console.error("Error:", err);
      setErrorMessage("Error while processing the form");
      setIsFormProcessing(false);
    }
  };

  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">
                  {categoryId ? "Edit Category" : "Add Category"}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="frmwdth_cntr">
                <div className="col-lg-12">
                  <div className="card card-primary card-outline">
                    <form
                      className="form-horizontal"
                      onSubmit={handleAddCategory}
                    >
                      <div className="card-body">
                        {/* Category Field */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Category<span className="f_red">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                          <input
  className="form-control"
  type="text" // You can change this to "number", "email", etc., depending on the type of input you want
  value={category}
  onChange={(e) => setCategory(e.target.value)}
  placeholder="Enter category"
/>
                          </div>
                        </div>

                        {/* Subcategory Field */}
                        <div className="form-group row">
                          <label className="col-12 col-md-4 col-form-label">
                            Subcategory<span className="f_red">*</span>
                          </label>
                          <div className="col-12 col-md-8">
                          <input
  className="form-control"
  type="text"
  value={subcategory}
  onChange={(e) => setSubcategory(e.target.value)}
  placeholder="Enter subcategory"
/>
              
                          </div>
                        </div>

                        {/* Error Message */}
                        {errorMessage && (
                          <div className="text-danger">{errorMessage}</div>
                        )}

                        {/* Success Message */}
                        {successMessage && (
                          <div className="text-success">{successMessage}</div>
                        )}
                      </div>

                      {/* Form Submit Button */}
                      <div className="card-footer text-center">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={isFormProcessing}
                        >
                          {categoryId ? "Update" : "Add"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AddCategory;
